import { Component } from '@angular/core';
import { NavController, NavParams,ViewController } from 'ionic-angular';
import { DbservicesProvider } from '../../providers/dbservices/dbservices';

@Component({
  selector: 'page-delivery-time',
  templateUrl: 'delivery-time.html',
})
export class DeliveryTimePage {

 delivery_slot;
 check_default= 1;

  constructor(public DBservice: DbservicesProvider,public viewCtrl: ViewController,public navCtrl: NavController, public navParams: NavParams) {
  	this.delivery_slot = navParams.get('delivery')
  	console.log(this.delivery_slot)
	this.get_restaurant_preparation_time()
	if(localStorage.check_default == 'true')
		this.check_default = 1;
	else
		this.check_default = 0;
  }

  checkdefault(){
    localStorage.check_default = this.check_default;
   }

  get_restaurant_preparation_time(){
    var orderdata = {
      business:localStorage.restaurant
    }
    this.DBservice.get_restaurant_preparation_time(orderdata)
      .then(data => {
        console.log(data);
        this.delivery_slot = data.message;
        
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }


  select_addon(item){
    if(item.is_default == false)
      item.is_default = 0;
    else
      item.is_default = 1;
  	var orderdata = {
      business:localStorage.restaurant,
      preparation_time_id:item.name,
      estimated_time:item.estimated_time,
      is_default: item.is_default
    }
    this.DBservice.update_restaurant_time(orderdata)
      .then(data => {
        console.log(data);
  	      this.get_restaurant_preparation_time()

        // this.doRefresh()
        // this.delivery_slot = data.message;
        
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  	// this.viewCtrl.dismiss(item)
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DeliveryTimePage');
  }


}



// WEBPACK FOOTER //
// ./src/pages/delivery-time/delivery-time.ts